export interface GoogleRecaptchaProviderProps {
  siteKey: string;
  headerName?: string;
  children: React.ReactNode;
}

export interface GoogleRecaptchaContextValue {
  getToken: () => Promise<string>;
  reset: () => void;
  headerName: string;
}

export interface GoogleRecaptchaManagerRef {
  execute: () => Promise<string>;
  reset: () => void;
}

export function validateSiteKey(siteKey: string): void {
  if (!siteKey || typeof siteKey !== "string" || siteKey.trim().length === 0) {
    throw new Error(
      "GoogleRecaptchaProvider: siteKey is required and must be a non-empty string"
    );
  }
}
